module.exports = __webpack_public_path__ + "img/3symbol-black.54003b06.svg";